import { connect } from 'react-redux';
// Components
import ForgotPassword from './ForgotPassword';

// Actions
import { forgotPassword } from 'store/reducers/login/actions';
import { gtmUserEvent } from 'store/reducers/gtm/actions';

export default connect(
  null,
  { forgotPassword, gtmUserEvent },
  null,
  {
    withRef: true
  }
)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/pages/User/SignIn/components/ForgotPassword/ForgotPasswordContainer.js